import React from "react";
import { FaAngleDown } from "react-icons/fa";
import { ChatIcon, CogIcon } from "@heroicons/react/solid";
import { LogoutIcon } from "@heroicons/react/outline";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ROUTES from "../../free/constants/routes";
import Menu from "@mui/material/Menu";
import { LocalStorageService } from "../../services";
// get user data from state
const authData = (state) => state.auth.client;
// get step data from redux main state
const data = (state) => state.dashboard;

let menuItems = [
  {
    name: "Candidate Report",
    icon: <ChatIcon className="h-5 w-5  " />,
  },
  {
    name: "Support Centre",
    path: "/support",
    icon: <CogIcon className="h-5 w-5  " />,
  },
  {
    name: "Log Out",
    path: "/",
    icon: <LogoutIcon className="h-5 w-5  " />,
  },
];

function Dropdown(props) {
  const user = useSelector(authData);
  let clientData = useSelector(data);
  let { campaigns } = clientData;

  let navigate = useNavigate();

  let handleLogout = () => {
    props.logout();
    props.stepHandler();
    navigate(`/`, { replace: true });
  };

  let handleReport = () => {
    let totalCamps = campaigns && campaigns.length;
    if (totalCamps > 0) {
      LocalStorageService.remove("path");
      navigate(`${ROUTES.REPORT}`);
    } else {
      props.showIsCampaign(true);
      setAnchorEl(null);
    }
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <div className="ml-12">
      <div className="relative block text-left">
        <button
          type="button"
          onClick={handleClick}
          className="flex flex-row items-center"
        >
          <p className="font-semibold text-lg text-gray-700 " id="menu-button">
            {user && user.name}
          </p>
          <FaAngleDown className="mx-2" />
        </button>

        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          {menuItems &&
            menuItems.map((item, index) => {
              return (
                <div key={index}>
                  {item.name === "Candidate Report" ? (
                    <button
                      onClick={() => handleReport()}
                      className={`cursor-pointer border-b-2  ml-0.5 flex flex-row items-center  justify-between p-2 text-[#3B4345] hover:text-[#007E8C]`}
                    >
                      {item.icon}
                      <p className="block  text-sm ml-2">{item.name}</p>
                    </button>
                  ) : item.name === "Log Out" ? (
                    <div
                      onClick={handleLogout}
                      className={`cursor-pointer ml-0.5 flex flex-row items-center p-2 text-[#3B4345] hover:text-[#007E8C]`}
                    >
                      {item.icon}
                      <p className="block text-sm ml-2">{item.name}</p>
                    </div>
                  ) : (
                    <div
                      onClick={() => {
                        navigate(`${ROUTES.MENUPAGES}`);
                      }}
                      className={`cursor-pointer flex flex-row items-center border-b-2   p-2 text-[#3B4345] hover:text-[#007E8C]`}
                    >
                      {item.icon}
                      <p className="block  text-sm ml-2">{item.name}</p>
                    </div>
                  )}
                </div>
              );
            })}
        </Menu>
      </div>
    </div>
  );
}

export default Dropdown;
